import { AUTH_BROADCAST_CHANNEL_KEY, type AuthEventType } from '../../auth-core/constants/auth.constants';

export interface AuthSyncMessage {
  type: AuthEventType;
  payload?: unknown;
}

/** Create the shared BroadcastChannel used for cross-tab auth synchronization. */
export function createAuthBroadcastChannel(): BroadcastChannel {
  return new BroadcastChannel(AUTH_BROADCAST_CHANNEL_KEY);
}

/** Broadcast an auth event to all same-origin tabs/windows via the channel. */
export function broadcastAuthEvent(channel: BroadcastChannel, message: AuthSyncMessage): void {
  channel.postMessage(message);
}

/** Register a handler for incoming auth sync messages. The caller is responsible for calling channel.close() when done. */
export function onAuthBroadcastEvent(channel: BroadcastChannel, handler: (message: AuthSyncMessage) => void): void {
  channel.onmessage = (event: MessageEvent<AuthSyncMessage>) => handler(event.data);
}
